export default __webpack_public_path__ + "static/media/CDC_en.ba869ff6.svg";